export default {
  INDEX: "/",
  ERROR: '/error',
  CREATE: "/create",
  CHOOSE: "/choose",
  COLLAGE: "/collage/:hash",
};
